"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUsersEndpoints = createUsersEndpoints;
/**
 * Kullanıcının KENDİ hesabı: profil, gizlilik, rıza defteri, bildirim tercihleri,
 * cihaz jetonu ve kişisel dışa aktarım.
 *
 * KIRMIZI ÇİZGİ 3: `dataExports` ücretsiz ve sınırsızdır — bu alan gruba
 * herhangi bir paket/kota parametresi EKLENMEZ.
 */
function createUsersEndpoints(client) {
    return {
        users: {
            me: () => client.call('/users/me', 'get', {}),
            updateMe: (input) => client.call('/users/me', 'patch', { body: input }),
            interests: () => client.call('/users/me/interests', 'get', {}),
            setInterests: (input) => client.call('/users/me/interests', 'put', { body: input }),
            completeOnboarding: () => client.call('/users/me/onboarding/complete', 'post', {}),
            identities: () => client.call('/users/me/identities', 'get', {}),
            unlinkIdentity: (identityId) => client.call('/users/me/identities/{id}', 'delete', { path: { id: identityId } }),
        },
        account: {
            privacy: () => client.call('/users/me/privacy', 'get', {}),
            updatePrivacy: (input) => client.call('/users/me/privacy', 'patch', { body: input }),
            deletionStatus: () => client.call('/users/me/deletion', 'get', {}),
            requestDeletion: (input) => client.call('/users/me/deletion', 'post', { body: input }),
            cancelDeletion: () => client.call('/users/me/deletion', 'delete', {}),
        },
        consents: {
            documentVersions: () => client.call('/consents/document-versions', 'get', {}),
            history: () => client.call('/consents', 'get', {}),
            current: () => client.call('/consents/current', 'get', {}),
            record: (input) => client.call('/consents', 'post', { body: input }),
        },
        notifications: {
            preferences: () => client.call('/users/me/notification-preferences', 'get', {}),
            updatePreferences: (input) => client.call('/users/me/notification-preferences', 'put', { body: input }),
            /**
             * BİLDİRİM MERKEZİ (uygulama içi kayıt). Tercihten AYRIDIR: kayıt kanal
             * kapalı olsa da yazılır (K3), bu uçlar onu okur.
             */
            feed: (query = {}) => client.call('/users/me/notifications', 'get', { query }),
            unreadCount: () => client.call('/users/me/notifications/unread-count', 'get', {}),
            markRead: (id) => client.call('/users/me/notifications/{id}/read', 'patch', { path: { id } }),
            markAllRead: () => client.call('/users/me/notifications/read-all', 'post', {}),
            /**
             * ALDIĞIM DUYURUNUN TAM METNİ (T4, Story 5). Almamış kişi, kurum hesabı,
             * başka duyuru ve personelin gizlediği duyuru AYNI 404'ü alır.
             */
            receivedAnnouncement: (announcementId) => client.call('/users/me/announcements/{announcementId}', 'get', {
                path: { announcementId },
            }),
            /** Duyurularını kapattığın kurumlar (Story 2, K2). Yalnız çağıranın kendi durumu. */
            announcementMutes: () => client.call('/users/me/announcement-mutes', 'get', {}),
            /** "Bu kurumdan duyuru alma" (tüm kanallar, idempotent). */
            muteOrganizationAnnouncements: (organizationId) => client.call('/users/me/announcement-mutes/{organizationId}', 'put', {
                path: { organizationId },
            }),
            /** Ayarlarda "Yeniden aç" (idempotent). */
            unmuteOrganizationAnnouncements: (organizationId) => client.call('/users/me/announcement-mutes/{organizationId}', 'delete', {
                path: { organizationId },
            }),
        },
        push: {
            /** Story 9.2: FCM cihaz jetonu kaydı (idempotent upsert). */
            registerDevice: (input) => client.call('/users/me/devices', 'post', { body: input }),
            /** Jeton URL'ye konmaz (log sızıntısı) — silme POST gövdesiyle. */
            removeDevice: (input) => client.call('/users/me/devices/remove', 'post', { body: input }),
        },
        dataExports: {
            request: (input) => client.call('/users/me/exports', 'post', { body: input }),
            list: () => client.call('/users/me/exports', 'get', {}),
            get: (jobId) => client.call('/users/me/exports/{jobId}', 'get', { path: { jobId } }),
        },
    };
}
//# sourceMappingURL=users.js.map